export default __webpack_public_path__ + "5b4b22e.png";